import React from 'react'
import { Card, Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import lekeTedavisi from '../../images/home/product_cat/16001613825223.jpg';
import ciltBakimi from '../../images/home/product_cat/16002483614992.jpg';
import kimyasalPeeling from '../../images/home/product_cat/1600248563806.jpg';
import botox from '../../images/home/product_cat/16001621013040.jpg';
import dolgu from '../../images/home/product_cat/16002484183426.jpg';
import prp from '../../images/home/product_cat/16002484584606.jpg';
import mezoterapi from '../../images/home/product_cat/16002485293517.jpg';
import dermoroller from '../../images/home/product_cat/16001664438222.jpg';
import pdo from '../../images/home/product_cat/16001666366178.jpg';


const products = [
    { title: "Leke Tedavisi", image: lekeTedavisi },
    { title: "Cilt Bakımı", image: ciltBakimi },
    { title: "Kimyasal Peeling", image: kimyasalPeeling },
    { title: "Botox Uygulamaları", image: botox },
    { title: "Dolgu Uygulamaları", image: dolgu },
    { title: "PRP Uygulamaları", image: prp },
    { title: "Mezoterapi Uygulamaları", image: mezoterapi },
    { title: "Dermoroller Uygulamaları", image: dermoroller },
    { title: "PDO İpleri ve Cilt Germe", image: pdo }
];

const KozmetikHomeItems = () => {

    const handleScrollToTop = () => {
        window.scrollTo(0, 0);
    };

    return (
        <div>
            <Container>
                <Row className='justify-content-md-center'>
                    {products.map((product, index) => (
                        <Col key={index} xs={12} sm={6} md={4} lg={3} xl={3} className='mb-3'>
                            <Card
                                className='sub-items-card'
                                as={Link}
                                to={`/kozmetik-uygulamalar?title=${encodeURIComponent(product.title)}`} 
                                onClick={handleScrollToTop}
                            >
                                <Card.Body>
                                    <p style={{ fontSize: '14px' }}>{product.title}</p>
                                    <div className='card-image-frame'>
                                        <Image src={product.image} rounded className='exec-summary-images2' />
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </div>
    );

}

export default KozmetikHomeItems